import { render, staticRenderFns } from "./AdminNationalityButton.vue?vue&type=template&id=1df5a771"
import script from "./AdminNationalityButton.vue?vue&type=script&lang=js"
export * from "./AdminNationalityButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports